import { render, staticRenderFns } from "./FieldsViewSortBy.vue?vue&type=template&id=340c1071&"
import script from "./FieldsViewSortBy.vue?vue&type=script&lang=ts&"
export * from "./FieldsViewSortBy.vue?vue&type=script&lang=ts&"
import style0 from "./FieldsViewSortBy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRadio,VRadioGroup,VSpacer})
